import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import bettingBg from './assets/images/betting-bg.png';
import trend1 from './assets/images/trend-1.png';
import trend2 from './assets/images/trend-2.png';
import trend3 from './assets/images/trend-3.png';
import trend4 from './assets/images/trend-4.png';
import bet1 from './assets/images/bet-1.png';
import bet2 from './assets/images/bet-2.png';
import bet3 from './assets/images/bet-3.png';
const Betting = () => {
    return (
        // <!-- Bettbet->
        <section id="betting" className="betting section">
          <div
            className="bg__holder"
            style={{ background: `url(${bettingBg})`, backgroundSize: 'cover' }}
          ></div>
          {/* <!--// bg__holder  --> */}
          <div className="container">
            <div className="row gx-4 gy-5 gx-lg-5">
              <div className="col-xl-6">
                <p className="section__para one" data-aos="fade-up">Youbie</p>
                <h2 className="heading__1" data-aos="fade-up">Online Betting</h2>
                <p className="section__para two" data-aos="fade-up">
                  Bet, Watch and Earn!
                </p>
                <p className="para" data-aos="fade-up">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </p>
                <ul className="betting-list">
                  <li className="betting-list__item" data-aos="fade-up">
                    <div className="item-img">
                      <img
                        src={trend1}
                        alt="Bet"
                        width="75"
                        height="68"
                        className="img-fluid"
                      />
                    </div>
                    <div className="details">
                      <h4 className="betting__title">Bet</h4>
                      <p className="betting__text">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      </p>
                    </div>
                  </li>
                  <li className="betting-list__item" data-aos="fade-up">
                    <div className="item-img">
                      <img
                        src={trend2}
                        alt="Watch"
                        width="75"
                        height="68"
                        className="img-fluid"
                      />
                    </div>
                    <div className="details">
                      <h4 className="betting__title">Watch</h4>
                      <p className="betting__text">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      </p>
                    </div>
                  </li>
                  <li className="betting-list__item" data-aos="fade-up">
                    <div className="item-img">
                      <img
                        src={trend3}
                        alt="Earn"
                        width="75"
                        height="68"
                        className="img-fluid"
                      />
                    </div>
                    <div className="details">
                      <h4 className="betting__title">Earn</h4>
                      <p className="betting__text">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                      </p>
                    </div>
                  </li>
                </ul>
                <h3 className="heading__3">Coming soon...</h3>
              </div>

              <div className="col-xl-6" data-aos="fade-up">
              <Carousel autoPlay interval="2500" transitionTime="500" showArrows={true}>
                <div>
                        <img
                          src={bet1}
                          alt="slide"
                          width="520px"
                          height="400px"
                          className="slide__img"
                        />
                        </div>
                        <div>
         
                        <img
                          src={bet2}
                          alt="slide"
                          width="520px"
                          height="400px"
                          className="slide__img"
                        />
                        </div>
                  
                        <div>
                        <img
                          src={bet3}
                          alt="slide"
                          width="520px"
                          height="400px"
                          className="slide__img"
                        />


                        </div>
                        <div>
                          
                        <img
                          src={trend4}
                          alt="slide"
                          width="520px"
                          height="400px"
                          className="slide__img"
                        />

                        </div>

                        <div>
                        <img
                          src={bet1}
                          alt="slide"
                          width="520px"
                          height="400px"
                          className="slide__img"
                        />
                        </div>
                        <div>
                        <img
                          src={trend4}
                          alt="slide"
                          width="520px"
                          height="400px"
                          className="slide__img"
                        />


                        </div>
                       
                 
               
                
                </Carousel>
                </div>
            </div>
          </div>
        </section>
        // <!-- Betting -->
    );
};

export default Betting;